module.exports = __webpack_public_path__ + "static/media/holly-berry.0b1f0142.svg";